import { Link, useLocation } from 'react-router-dom';
import { useCart } from '@/hooks/useCart';
import { HeaderAuth } from './HeaderAuth';
import HeaderSearch from './HeaderSearch';

// 128×128 transparent WebP (~6 KB, 2× the 64px display size), served from our own origin.
// The 320px original /logo-header.webp is kept for other consumers.
const LOGO_SRC = '/logo-header-128.webp';

const ShoppingCartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="8" cy="21" r="1"/>
    <circle cx="19" cy="21" r="1"/>
    <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
  </svg>
);

interface DesktopHeaderProps {
  onSearch: (value: string) => void;
}

export const DesktopHeader = ({ onSearch }: DesktopHeaderProps) => {
  const { cartItems } = useCart();
  const location = useLocation();
  
  const shouldShowSearch = !location.pathname.startsWith('/products') || location.search;

  return (
    <div className="hidden md:flex justify-between items-center gap-4">
      <div className="flex items-center gap-3 flex-shrink-0">
        <Link to="/">
          <img
            src={LOGO_SRC}
            alt="Kooperasie Veevoer Winkel"
            className="h-16 w-auto object-contain"
            width={64}
            height={64}
            loading="eager"
            decoding="async"
          />
        </Link>
        <h1 className="text-springbok-600 font-playfair font-bold text-lg md:text-2xl lg:text-3xl uppercase tracking-wide">
          KOOPERASIE VEEVOER WINKEL
        </h1>
      </div>

      {shouldShowSearch && (
        <div className="flex-1 max-w-md mx-4">
          <HeaderSearch onSearch={onSearch} />
        </div>
      )}

      <nav className="flex items-center space-x-2 flex-shrink-0">
        <HeaderAuth />
        
        <Link to="/cart" className="p-2 relative group">
          <div id="desktop-cart-target" className="group-hover:text-springbok-500 transition-colors">
            <ShoppingCartIcon />
          </div>
          {cartItems?.reduce((sum, item) => sum + (item.quantity || 1), 0) > 0 && (
            <span className="absolute -top-1 -right-1 bg-gold-400 text-springbok-800 rounded-full text-xs w-5 h-5 flex items-center justify-center">
              {cartItems.reduce((sum, item) => sum + (item.quantity || 1), 0)}
            </span>
          )}
        </Link>
      </nav>
    </div>
  );
};
